export default "__VITE_ASSET__dce8989c__"